<template>
    <b-modal size="xl" button-size="sm" hide-footer v-model="modalAberto" :title="prefix + titlePage" @abort="cancelar"
        @hidden="cancelar">
        <b-form @submit.prevent="save">
            <b-card>
                <b-container fluid>
                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="8">
                            <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" "
                                :error="$v.form.descricao" v-model="form.descricao" label="Descrição*" />
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="8">
                            <LgFinderPageTipoModalidade :prefix="prefix + title + ' > '" v-model="form.tipoModalidade" label="Tipo de Modalidade:*"
                                :error="$v.form.tipoModalidade" @onSelect="setTipoModalidade" />
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-center">
                        <b-col cols="12" sm="8">
                            <b-form-group label="Status:*" class="ml-3">
                                <b-form-radio-group v-model="form.situacao" :options="situacaoOptions" size="sm"
                                    name="status-inline"></b-form-radio-group>
                            </b-form-group>

                        </b-col>
                    </b-row>
                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvarLocalCadastro" class=" my-2" size="sm" pill variant="success"
                                @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvarLocalCadastro" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelarLocalCadastro" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelarLocalCadastro" title="Cancelar"></b-tooltip>

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>


                </b-container>
            </b-card>
        </b-form>
    </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFinderPageTipoModalidade from "@/components/Finders/LgFinderPageTipoModalidade.vue";
import ModalidadeContratoService from "@/core/api/ModalidadeContratoService";

export default {
    components: { LgFormInput, LgFinderPageTipoModalidade },

    props: {
        id: Number,
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Cadastro",
        },
        showModal: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            modalAberto: true,
            titlePage: "Cadastro",
            form: {
                descricao: "",
                tipoModalidade: null,
                situacao: null,
            },
            situacaoOptions: [
                { key: 1, text: "Ativo", value: 1 },
                { key: 0, text: "Inativo", value: 0 },
            ],
        };
    },

    validations: {
        form: {
            descricao: { required },
            tipoModalidade: { required },
            situacao: { required },
        },
    },

    watch: {
        id: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.carregarModalidadeContrato(newVal);
                } else {
                    this.resetForm();
                }
            },
        },
    },

    methods: {
        async carregarModalidadeContrato(id) {
            const { data } = await ModalidadeContratoService.findById(id);
            this.form = {
                descricao: data.descricao,
                tipoModalidade: { id: data.tipoModalidadeId, descricao: data.tipoModalidadeDescricao },
                situacao: data.situacao,
            };
            this.titlePage = "Cadastro";
        },

        setTipoModalidade(tipoModalidade) {
            this.form.tipoModalidade = tipoModalidade;
        },

        async save() {
            if (!this.formIsValid()) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "OPS! Verifique os campos do cadastro.",
                });
                return;
            }

            if (this.id) {
                await ModalidadeContratoService.update({
                    cod: this.id,
                    descricao: this.form.descricao,
                    codTipoModalidade: this.form.tipoModalidade.id,
                    situacao: this.form.situacao,
                });
            } else {
                await ModalidadeContratoService.create({
                    descricao: this.form.descricao,
                    codTipoModalidade: this.form.tipoModalidade.id,
                    situacao: this.form.situacao,
                });
            }
            this.$emit("update");
            this.$emit("close");

            this.$notify({
                type: "success",
                message: "Registro salvo com sucesso",
            });

        },

        cancelar() {
            this.modalAberto = false;
            this.$emit("close");
        },

        resetForm() {
            this.form = {
                descricao: "",
                tipoModalidade: null,
                situacao: null,
            };
            this.titlePage = "Cadastro";
        },

        formIsValid() {
            return (
                this.$v.form.$pending === false && this.$v.form.$invalid === false
            );
        },
    },
};
</script>
